import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CookieConsentBannerStyles as styles } from '../css/styles';
import { hasValidConsent, setConsent, initAnalytics } from '../utils/cookieConsent';

const CookieConsentBanner: React.FC = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!hasValidConsent()) {
            setVisible(true);
        }
    }, []);

    const handleAcceptAll = () => {
        setConsent(true);
        initAnalytics();
        setVisible(false);
    };

    const handleNecessaryOnly = () => {
        setConsent(false);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className={styles.banner}>
            <div className={styles.content}>
                <p className={styles.intro}>{t('cookie.description')}</p>
                <div className={styles.categories}>
                    <div className={styles.category}>
                        <span className={styles.categoryName}>
                            {t('cookie.necessary')}
                            <span className={styles.alwaysOn}>{t('cookie.alwaysOn')}</span>
                        </span>
                        <p className={styles.categoryDesc}>{t('cookie.necessaryDesc')}</p>
                    </div>
                    <div className={styles.category}>
                        <span className={styles.categoryName}>{t('cookie.analytics')}</span>
                        <p className={styles.categoryDesc}>{t('cookie.analyticsDesc')}</p>
                    </div>
                </div>
            </div>
            <div className={styles.actions}>
                <button className={styles.acceptBtn} onClick={handleAcceptAll}>
                    {t('cookie.acceptAll')}
                </button>
                <button className={styles.necessaryBtn} onClick={handleNecessaryOnly}>
                    {t('cookie.necessaryOnly')}
                </button>
                <a className={styles.policyLink} href="/privacy">
                    {t('cookie.learnMore')}
                </a>
            </div>
        </div>
    );
};

export default CookieConsentBanner;
